// @flow
import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import StandaloneSearchBox from 'react-google-maps/lib/components/places/StandaloneSearchBox'
import Icon from '../icons/icon'
import MapBox from '../maps/map-box'
import Field from 'redux-form/lib/Field'

const LocationBox = (props: Object) => {
  const {
    id,
    label,
    name,
    value,
    lat,
    lng,
    placeholder,
    disabled,
    displayMap,
    onInputChange,
    onInputFocus,
    onSearchBoxMounted,
    onAddressChanged,
    onPositionChanged,
    hasError,
    errorText,
    autoFocus
  } = props
  const fieldClasses = cx({
    'form-field': true,
    'has-icon': true,
    [props.theme]: !!props.theme,
    'has-error': hasError
  })
  const inputClasses = cx({
    'form-input': true,
    'is-filled': Boolean(value)
  })
  return (
    <div className={fieldClasses}>
      <StandaloneSearchBox
        ref={onSearchBoxMounted}
        onPlacesChanged={onAddressChanged}
      >
        <Field
          type='text'
          id={id}
          name={name}
          component='input'
          value={value}
          placeholder={placeholder}
          className={inputClasses}
          disabled={disabled}
          onChange={onInputChange}
          onFocus={onInputFocus}
          autoFocus={autoFocus}
        />
      </StandaloneSearchBox>
      <label className='form-label floating-label' htmlFor={id}>
        {label}
      </label>
      {hasError && errorText && <span className='error-text'>{errorText}</span>}
      <Icon name='map-pin' />
      <br />
      {!!displayMap && (
        <MapBox
          lat={lat}
          lng={lng}
          containerElement={
            <div
              className='map-box'
              id='map-box'
              style={{ marginTop: '1rem' }}
            />
          }
          mapElement={<div style={{ height: '100%' }} />}
          onPositionChanged={onPositionChanged}
          isMarkerDraggable
        />
      )}
    </div>
  )
}

LocationBox.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  displayMap: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  hasError: PropTypes.bool.isRequired,
  errorText: PropTypes.string,
  theme: PropTypes.string,
  onSearchBoxMounted: PropTypes.func.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onInputFocus: PropTypes.func.isRequired,
  onAddressChanged: PropTypes.func.isRequired,
  autoFocus: PropTypes.bool
}

LocationBox.defaultProps = {
  theme: 'dark-theme'
}

export default LocationBox



// WEBPACK FOOTER //
// ./src/ui/forms/location-box.js